export default {
  en: {
    team: {
      title: 'Team name',
      alias: 'Team alias',
      search: 'Search',
      reset: 'Reset',
      private: 'private',
      registrationDate: 'in Gitflic with {date}',
      youAreOwner: 'You owner',
      isStarred: 'Favorites',
      addStarred: 'To Favorites',
      inGitflic: 'Team {title} in Gitflic',
      subgroup: 'subgroup',
      owner: {
        isOwner: 'Owner',
        inTeam: 'In team',
        inCompany: 'In company'
      },
      leave: {
        title: 'Leave team',
        description: 'When you exit the team {title}, you will lose access to it.',
        controlString: {
          description: 'Please write <b>{controlString}</b> to confirm'
        }
      },
      report: {
        title: 'Report team'
      }
    }
  },
  ru: {
    team: {
      title: 'Название команды',
      alias: 'Алиас команды',
      search: 'Поиск',
      reset: 'Сбросить',
      private: 'приватная',
      registrationDate: 'в Gitflic с {date}',
      youAreOwner: 'Вы владелец',
      isStarred: 'Избранное',
      addStarred: 'В избранное',
      inGitflic: 'Команда {title} в Gitflic',
      subgroup: 'подгруппа',
      owner: {
        isOwner: 'Вы владелец',
        inTeam: 'В команде',
        inCompany: 'В компании'
      },
      leave: {
        title: 'Покинуть команду',
        description: 'При выходе из команды {title} вы потеряете к ней доступ.',
        controlString: {
          description: 'Пожалуйста, напишите <b>{controlString}</b> для подтверждения'
        }
      },
      report: {
        title: 'Пожаловаться на команду'
      }
    }
  }
};
